import amplitude from 'amplitude-js';
import {v4 as uuidv4} from 'uuid';
import { getFocusUser, isUserLoggedIn } from '../services/user-credentials';

const GATSBY_ANALYTICS_API_KEY = process.env.GATSBY_ANALYTICS_API_KEY;

export interface Event {
  name: string;
  props?: unknown;
}

class AnalyticsFactory {

  static instance: AnalyticsFactory;

  private constructor() {
    console.log("constructor called!");
  }

  public static getInstance(): AnalyticsFactory {
    if (!AnalyticsFactory.instance) {
      AnalyticsFactory.instance = new AnalyticsFactory();
      amplitude.getInstance().init(GATSBY_ANALYTICS_API_KEY);
    }
    return AnalyticsFactory.instance;
  }

  public logEvent(event: Event) {
    amplitude.getInstance().logEvent(event.name, event.props);
  }

  public setUser(userId: string) {
    amplitude.getInstance().setUserId(userId);
  }

}

export default AnalyticsFactory;
